import * as StorageService from "../services/StorageService.js";
import {LOCALSTORAGE_ITEMS, USER_TYPES} from "../util/Constants";
import * as CryptoJS from "crypto-js";
import * as UserService from "./UserService";
import {getShopDetailsByName} from "./ShopService";
import * as RestClient from "../util/api/restClient";
import * as ClientConfig from "../config/ClientConfig";
import {EventBus} from "../util/EventBus";


const configApp = async () => {
    let browserLang =
        (navigator.languages && navigator.languages[0]) ||
        navigator.language ||
        navigator.userLanguage;
    StorageService.setItem(LOCALSTORAGE_ITEMS.LOCALE, browserLang);

    const shopName = StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_NAME);
    if (shopName) {
        let shopDetails = StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS)? JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS)): null;

        if (StorageService.getItem(LOCALSTORAGE_ITEMS.USER_TYPE) !== USER_TYPES.VERIFIED.toString()) {
            const storageUserEmail = StorageService.getItem(LOCALSTORAGE_ITEMS.USER_EMAIL);

            if(!storageUserEmail){

                const zonizCaptcha = generateZonizCaptcha();
                const userEmail = await generateAnonymousEmail(zonizCaptcha);
                const userToken = await createAnonymousAccount(userEmail);

                StorageService.setItem(LOCALSTORAGE_ITEMS.USER_EMAIL, userEmail);
                StorageService.setItem(LOCALSTORAGE_ITEMS.USER_EMAIL_ANONYMOUS, userEmail);
                StorageService.setItem(LOCALSTORAGE_ITEMS.USER_INFO_ANONYMOUS, JSON.stringify(userToken));
                StorageService.setItem(LOCALSTORAGE_ITEMS.ACCESS_TOKEN, userToken.token);
                StorageService.setItem(LOCALSTORAGE_ITEMS.USER_TYPE, USER_TYPES.ANONYMOUS);
            }
        }

        const ts = StorageService.getItem(LOCALSTORAGE_ITEMS.CALL_TS);
        if (ts && new Date().getTime() - ts > 30 * 60 * 1000) {// 30 minute 30*60*1000
            console.log("30 mins passed...removing SHOP_DETAILS from storage");
            StorageService.removeItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS);
            shopDetails = null;
        }

        if(shopDetails == null || shopDetails.name !== shopName){
            shopDetails = await getShopDetailsByName(shopName);
            StorageService.setItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS, JSON.stringify(shopDetails?.data));
            const shopLang = shopDetails?.data.lang;
            const intLang = shopDetails?.data.intLang;


            if (shopLang === browserLang) {
                document.documentElement.lang = shopLang;
            }else{
                document.documentElement.lang = intLang;
            }
        }
    }
}

const generateZonizCaptcha = () => {
    const t = new Date().getTime();
    return t+"."+CryptoJS.MD5(t + ".19857b38f").toString(CryptoJS.enc.Base64);
}

const generateAnonymousEmail = async (captcha) => {
    const response = await UserService.generateAnonymousEmail(captcha);
    if (response.ok) {
        return response.data.email;
    }
    else {
        EventBus.dispatch("genericErrorMsg");
        console.log("Error Generating Anonymous Email");
    }
}

const createAnonymousAccount = async (email) => {
    const body = {
        "email": email,
    }
    const response = await UserService.createAnonymousAccount(body);
    if (response.ok) {
        return response.data;
    }
    else {
        EventBus.dispatch("genericErrorMsg");
        console.log("Error Creating Anonymous Account");
    }
}


const deleteAccount =  async () => {
    return RestClient.handleResponse(() => {
        const finalURL = ClientConfig.URL_RESOURCE_SERVER + "/api/user/deleteaccount";
        const response = fetch(finalURL, {
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                "X-Zoniz-Token": StorageService.getItem(LOCALSTORAGE_ITEMS.ACCESS_TOKEN),
                "X-Zoniz-User-Email": StorageService.getItem(LOCALSTORAGE_ITEMS.USER_EMAIL),
            }
        });
        return response;
    });
}


export {
    configApp,
    generateZonizCaptcha,
    generateAnonymousEmail,
    createAnonymousAccount,
    deleteAccount
}
